import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import "./Projects.css";
import { projects } from "../data/projects";

export default function Projects() {
  const { t } = useTranslation();

  return (
    <section className="projects" id="projects">
      <motion.h2
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        {t('nav_projects')}
      </motion.h2>

      <div className="projects-grid">
        {projects.map((project, index) => (
          <motion.div 
            className="project-card" 
            key={project.id}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.2 }}
            whileHover={{ y: -10 }}
          >
            {/* حاوية الصورة */}
            <div className="project-image">
              <img src={project.image} alt={t(project.titleKey)} />
              <div className="image-overlay"></div>
            </div>

            <div className="project-info">
              <h3>{t(project.titleKey)}</h3>
              <p>{t(project.descKey)}</p>

              <div className="tech">
                {project.tech.map((techItem, i) => (
                  <span key={i}>{techItem}</span>
                ))}
              </div>

              {/* زرار زيارة الموقع */}
              <a 
                href={project.link} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="visit-btn"
              >
                {t('view_project')}
              </a>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}